import { Feedback } from './feedback.model';

// Without this dynamic parameter AOT compiling will fail.
// @see https://angular.io/guide/angular-compiler-options#strictmetadataemit
// @dynamic
export class CorrectFeedback extends Feedback {
  public static fromDto(dto: any): CorrectFeedback {
    const feedback: CorrectFeedback = new CorrectFeedback();
    Feedback.mapBaseProperties(feedback, dto);
    return feedback;
  }
}
